import LandingPage from './components/HomePage';

function App() {
  return <LandingPage />;
}

export default App;
